<template>
    <div>
        <div v-if="Array.isArray(soups)">
            <span v-for="(soup, i) in soups" :key="soup.soupId">
                <span class="mdl-chip mdl-chip--deletable mdl-shadow--2dp" @click="editSoup(soup)">
                    <span class="mdl-chip__text">{{ soup.name }}</span>
                    <button type="button" class="mdl-chip__action" @click.stop="deleteSoup(i)">
                        <i class="material-icons">cancel</i>
                    </button>
                </span>                        &nbsp;
            </span>
        </div>
        <div class="mdl-chip mdl-shadow--2dp cursor-hand" v-on:click="addSoup()">
            <span class="material-icons mdl-chip__text">add</span>
        </div>

        <modal :open-counter="soupModalOpen" :small="true" @user-closed="reload()">
            <soup-item-editable :soup="soup" @save="addedSoup"></soup-item-editable>
        </modal>
    </div>
</template>

<script>
    import Modal from "./widgets/Modal";
    import SoupItemEditable from "./SoupItemEditable";

    export default {
        name: "MenuEditSoups",
        components: {SoupItemEditable, Modal},
        props: {
            soups: Array,
        },
        data: function () {
            return {
                soupModalOpen: 0,
                soup: undefined,
            }
        },
        methods: {
            deleteSoup: function (soupIndex) {
                this.soups.splice(soupIndex, 1);
                this.save();
            },
            addSoup: function () {
                this.soup = { soupCode: "", name: "", price: 0, foodRequired: false };
                this.soups.push(this.soup);

                this.soupModalOpen++;
            },
            editSoup: function(soup) {
                this.soup = soup;
                this.soupModalOpen++;
            },
            addedSoup: function () {
                this.soupModalOpen--;
                this.save();
            },
            save: function () {
                this.$emit("save");
            },
            reload: function () {
                this.$emit("reload");
            }
        }
    }
</script>

<style scoped>
    .cursor-hand {
        cursor: pointer;
    }
</style>